import { Component, ChangeDetectorRef, ViewChild, Output, EventEmitter, AfterViewInit } from '@angular/core';

import { QrScannerComponent } from '@uex/ngx-qrscanner';

@Component({
  selector: 'uex-qr-scanner',
  templateUrl: './qr-scanner.component.html'
})
export class QRScannerComponent implements AfterViewInit {
  @ViewChild(QrScannerComponent, { static: true }) scanner: QrScannerComponent;

  @Output('onScan') scanEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private _changeDetectorRef: ChangeDetectorRef
  ) { }

  public area_visible = true;

  public ngAfterViewInit() { }

  public onScan(event) {
    this.scanEvent.emit(event);
    this.flash();
  }

  public flash() {
    this.area_visible = false;
    this._changeDetectorRef.detectChanges();
    setTimeout(() => {
      this.area_visible = true;
      this._changeDetectorRef.detectChanges();
      setTimeout(() => {
        this.area_visible = false;
        this._changeDetectorRef.detectChanges();
        setTimeout(() => {
          this.area_visible = true;
          this._changeDetectorRef.detectChanges();
        }, 100);
      }, 50);
    }, 50);
  }

}
